import { useState } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { CreditCard, Building2, Settings } from 'lucide-react';
import CompanySubscriptionView from '@/components/admin/CompanySubscriptionView';
import AdminCompany from './AdminCompany';
import AdminConfig from './AdminConfig';

const AdminSettings = () => {
  const [activeTab, setActiveTab] = useState('subscription');

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl font-bold">Settings</h2>
        <p className="text-muted-foreground">Manage subscription, company information, and AI configuration</p>
      </div>

      <Tabs value={activeTab} onValueChange={setActiveTab} className="space-y-6">
        <TabsList className="grid w-full grid-cols-3 max-w-md">
          <TabsTrigger value="subscription" className="flex items-center gap-2">
            <CreditCard className="h-4 w-4" />
            <span className="hidden sm:inline">Subscription</span>
          </TabsTrigger>
          <TabsTrigger value="company" className="flex items-center gap-2">
            <Building2 className="h-4 w-4" />
            <span className="hidden sm:inline">Company</span>
          </TabsTrigger>
          <TabsTrigger value="config" className="flex items-center gap-2">
            <Settings className="h-4 w-4" />
            <span className="hidden sm:inline">AI Config</span>
          </TabsTrigger>
        </TabsList>

        <TabsContent value="subscription">
          <CompanySubscriptionView />
        </TabsContent>

        <TabsContent value="company">
          <AdminCompany />
        </TabsContent>

        <TabsContent value="config">
          <AdminConfig />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default AdminSettings;
